import { REPORT_TYPES, GRAPH_DATATYPE, QUALITATIVE_REPORT_LEVELS } from "../../../constants/app-constant";
import { getRandomUniqueColor, getLineGraphFormat } from "./format-utils";
import {
    VERTICALS,
    GRAPH_TYPES,
    CONSTANTS,
    useDynamicEntityColors,
} from "../../../constants/app-constant";
import { publicationPrintGenreFilterList } from "../../NewsAndAnalysis/NewAnalysis/AnalysisGroup/filter-constant";

const { V_ONLINE, V_PRINT } = VERTICALS;
const { PIE, TABLE, BAR_STACKED_EQUAL_HEIGHT, LINE, BAR_VERTICAL } = GRAPH_TYPES;
const {
    REPORTS: { TYPES },
} = CONSTANTS;

const {
    ENTITY,
    KEYWORD,
    JOURNALIST,
    CITY,
    PUBLICATION,
} = QUALITATIVE_REPORT_LEVELS;

const {
    JournalistEntityTrendCCM,
    JournalistEntityTrendIndex,
    JournalistEntityTrendNOA,
    JournalistEntityTrendReach,
    JournalistEntityTrendMAV,
    JournalistEntityTrendWordCount,
    JournalistEntityTonalityCCM,
    JournalistEntityTonalityIndex,
    JournalistEntityTonalityNOA,
    JournalistEntityTonalityMAV,
    JournalistEntityTonalityWordCount,
    JournalistEntityTonalityReach,
    JournalistKeywordTrendCCM,
    JournalistKeywordTrendIndex,
    JournalistKeywordTrendNOA,
    JournalistKeywordTrendReach,
    JournalistKeywordTrendMAV,
    JournalistKeywordTrendWordCount,
    JournalistKeywordTonalityCCM,
    JournalistKeywordTonalityIndex,
    JournalistKeywordTonalityNOA,
    JournalistKeywordTonalityMAV,
    JournalistKeywordTonalityWordCount,
    JournalistKeywordTonalityReach,
} = REPORT_TYPES;

const {
    JournalistEntitySOVOnline,
    JournalistEntitySOVPrint,
    JournalistEntityTrendOnline,
    JournalistEntityTrendPrint,
    JournalistEntityTonalityOnline,
    JournalistEntityTonalityPrint,
    JournalistKeywordSOVOnline,
    JournalistKeywordSOVPrint,
    JournalistKeywordTrendOnline,
    JournalistKeywordTrendPrint,
    JournalistKeywordTonalityOnline,
    JournalistKeywordTonalityPrint
} = GRAPH_DATATYPE;

export const getJournalistFromResponse = (d = []) => {
    const result = d;
    const journalist = result && result[result.sequence[0]].returnData.journalist;
    return journalist;
}

export const newFormatDataByJournalist = (
    d = [],
    report_type,
    graphDataType,
    selectedInlineGraphType,
    selectedInlineSentiment,
    selectedInlineEntity,
    selectedInlineDynamicFilter,
) => {
    const { online, print } = graphDataType;
    const isEntityLevel =
        online === JournalistEntitySOVOnline ||
        print === JournalistEntitySOVPrint ||
        online === JournalistEntityTrendOnline ||
        print === JournalistEntityTrendPrint ||
        online === JournalistEntityTonalityOnline ||
        print === JournalistEntityTonalityPrint;

    const isKeywordLevel =
        online === JournalistKeywordSOVOnline ||
        print === JournalistKeywordSOVPrint ||
        online === JournalistKeywordTrendOnline ||
        print === JournalistKeywordTrendPrint ||
        online === JournalistKeywordTonalityOnline ||
        print === JournalistKeywordTonalityPrint;


    const level =
        (isEntityLevel) ? ENTITY :
            (isKeywordLevel) ? KEYWORD :
                "No Level";

    const isTrend =
        report_type === JournalistEntityTrendCCM ||
        report_type === JournalistEntityTrendMAV ||
        report_type === JournalistEntityTrendNOA ||
        report_type === JournalistEntityTrendIndex ||
        report_type === JournalistEntityTrendWordCount ||
        report_type === JournalistEntityTrendReach ||
        report_type === JournalistKeywordTrendCCM ||
        report_type === JournalistKeywordTrendMAV ||
        report_type === JournalistKeywordTrendNOA ||
        report_type === JournalistKeywordTrendIndex ||
        report_type === JournalistKeywordTrendWordCount ||
        report_type === JournalistKeywordTrendReach;

    const isTonality =
        report_type === JournalistEntityTonalityCCM ||
        report_type === JournalistEntityTonalityMAV ||
        report_type === JournalistEntityTonalityNOA ||
        report_type === JournalistEntityTonalityIndex ||
        report_type === JournalistEntityTonalityWordCount ||
        report_type === JournalistEntityTonalityReach ||

        report_type === JournalistKeywordTonalityCCM ||
        report_type === JournalistKeywordTonalityMAV ||
        report_type === JournalistKeywordTonalityNOA ||
        report_type === JournalistKeywordTonalityIndex ||
        report_type === JournalistKeywordTonalityWordCount ||
        report_type === JournalistKeywordTonalityReach;


    const currentMeasure = (report_type) => {
        const measures = {
            NOA: "article_count",
            CCM: "ccmtotal",
            MAV: "mavtotal",
            Index: "indextotal",
            WC: "wordcounttotal",
            Reach: "reachtotal",
        };
        const noaRegex = /noa/i;
        const ccmRegex = /ccm/i;
        const mavRegex = /mav/i;
        const indexRegex = /index/i;
        const wordCountRegex = /wordCount/i;
        const reachRegex = /reach/i;
        if (noaRegex.test(report_type)) {
            return measures.NOA;
        } else if (ccmRegex.test(report_type)) {
            return measures.CCM;
        } else if (mavRegex.test(report_type)) {
            return measures.MAV;
        } else if (indexRegex.test(report_type)) {
            return measures.Index;
        } else if (wordCountRegex.test(report_type)) {
            return measures.WC;
        } else if (reachRegex.test(report_type)) {
            return measures.Reach;
        } else {
            console.log("No report name match found");
            return;
        }
    }
    // console.log('selectedInlineDynamicFilter', selectedInlineDynamicFilter)
    const measure = currentMeasure(report_type);
    if (isTrend) {
        return newFormatDataByTrend(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlineDynamicFilter.value);
    }
    else if (isTonality) {
        return newFormatDataByTonality(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlineDynamicFilter.value,
            selectedInlineSentiment.value);
    }
    else {
        return newFormatDataBySOV(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlineDynamicFilter.value
        );
    }
};

//{datasets: {label: "", backgroundColor: "", barThcikness: "", borderColor: ""/[], borderWidth: 1, data: [], 
//fill: false, lineTension: 0}}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}

const newFormatDataBySOV = (d = [], level, graphType, currentMeasure, entity, selectedTheme) => {
    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const journalist = dataObj && dataObj.journalist;
    const entities = dataObj && dataObj.entities;
    const labels = entities.map((ent) => ent.entity_name);
    const datasets = [];
    const colors = getRandomUniqueColor(journalist.length);
    const entityColors = getRandomUniqueColor(entities.length);
    let loopData = Object.keys(graphData);
    const legendSet = [];
    const legendSetLength = Math.ceil(loopData.length / 10);
    for (let x = 1, y = 0; x <= 1; x++) {
        const set = [];
        loopData && loopData.filter((v, i) => (i >= y && i < (x * 10))).forEach((val, idx) => {
            const label = val;
            const backgroundColor = colors[idx];
            const borderColor = backgroundColor;
            const borderWidth = 1;
            const fill = false;
            const data = [];
            entities && entities.forEach((ent) => {
                let currVal = 0;
                if (level === ENTITY && graphData.hasOwnProperty(val) && graphData[val].hasOwnProperty(ent.entity_name)) {
                    currVal = parseData(graphData[val][ent.entity_name][currentMeasure], true);
                } else if (graphData.hasOwnProperty(val) && graphData[val].hasOwnProperty(selectedTheme) && graphData[val][selectedTheme].hasOwnProperty(ent.entity_name)) {
                    currVal = parseData(graphData[val][selectedTheme][ent.entity_name][currentMeasure], true);
                }
                data.push(currVal);
            });
            set.push({ label, backgroundColor, borderColor, borderWidth, data, lineTension: 0, fill: "false", barThcikness: "flex" });
        });
        legendSet.push({ labels, datasets: set });
        y = x * 10;
    }
    if (graphType === BAR_STACKED_EQUAL_HEIGHT) {
        return legendSet;
    }

    const hcPieChartData = [];
    if (graphType === PIE) {
        entities && entities.forEach((ent, idx) => {
            const backgroundColor = (useDynamicEntityColors) ? (ent.color_code !== "#000000") ? ent.color_code : entityColors[idx] : entityColors[idx];
            let currVal = 0;
            if (level === ENTITY && graphData.hasOwnProperty(selectedTheme) && graphData[selectedTheme].hasOwnProperty(ent.entity_name)) {
                currVal = parseData(graphData[selectedTheme][ent.entity_name][currentMeasure], true);
            }
            hcPieChartData.push({ name: ent.entity_name, y: currVal, backgroundColor });
        });
        return { labels: [], datasets: [], hcPieChartData };
    }

}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}
const newFormatDataByTonality = (
    d = [],
    level,
    graphType,
    currentMeasure,
    entity,
    theme,
    sentiment) => {

    if (graphType === PIE) {
        return { labels: [], datasets: [], hcPieChartData: [{}] };
    }

    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const journalist = dataObj && dataObj.journalist;
    const entities = dataObj && dataObj.entities;
    const tonalities = dataObj && dataObj.tonality;
    const colors = getRandomUniqueColor(tonalities.length);
    const datasets = [];
    const labels = entities && entities.map((ent) => ent.entity_name);
    if (level === ENTITY) {
        tonalities.forEach((tone, idx) => {
            const label = tone;
            const backgroundColor = colors[idx];
            const data = [];
            entities && entities.forEach((ent) => {
                let currVal = 0;
                if (graphData[tone] && graphData[tone].hasOwnProperty(theme) && graphData[tone][theme].hasOwnProperty(ent.entity_name)) {
                    currVal = parseData(graphData[tone][theme][ent.entity_name][currentMeasure], true);
                }
                data.push(currVal);
            });
            datasets.push({ label, backgroundColor, borderColor: backgroundColor, borderWidth: 1, data, barThcikness: "flex", fill: false, lineTension: 0 });
        });
        return { labels, datasets };
    }

    const level1Keys = Object.keys(graphData);
    const level2Keys = [];
    level1Keys && level1Keys.forEach((date) => {
        const currLevel2KeyArray = Object.keys(graphData[date]);
        currLevel2KeyArray.length > 0 && currLevel2KeyArray.forEach((val, idx) => {
            if (level2Keys.indexOf(val) === -1) {
                level2Keys.push(val);
            }
        });
    });

    const level2Colors = getRandomUniqueColor(level2Keys.length);
    const legendSet = [];
    const legendSetLength = Math.ceil(level2Keys.length / 10);
    for (let x = 1, y = 0; x <= 1; x++) {
        const set = [];
        level2Keys && level2Keys.filter((v, i) => (i >= y && i < (x * 10))).forEach((val, idx) => {
            const label = val;
            const backgroundColor = level2Colors[idx];
            const data = [];
            entities && entities.forEach((ent) => {
                let currVal = 0;
                if (
                    graphData.hasOwnProperty(sentiment) &&
                    graphData[sentiment].hasOwnProperty(val) &&
                    graphData[sentiment][val].hasOwnProperty(theme) &&
                    graphData[sentiment][val][theme].hasOwnProperty(ent.entity_name)
                ) {
                    currVal = parseData(graphData[sentiment][val][theme][ent.entity_name][currentMeasure], true);
                }
                data.push(currVal);
            });
            set.push({ label, backgroundColor, borderColor: backgroundColor, borderWidth: 1, data, barThcikness: "flex", fill: false, lineTension: 0 });
        });
        legendSet.push({ labels, datasets: set });
        y = x * 10;
    }
    return legendSet;

}

//{datasets: {label: "", backgroundColor: "", barThcikness: "", borderColor: ""/[], borderWidth: 1, data: [], fill: false, lineTension: 0}}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}

const newFormatDataByTrend = (d = [], level, graphType, currentMeasure, entity, selectedTheme) => {
    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const journalist = dataObj && dataObj.journalist;
    const entities = dataObj && dataObj.entities;
    const labels = entities.map((ent) => ent.entity_name);
    const datasets = [];
    const level1Keys = graphData && Object.keys(graphData).sort();
    const level2Keys = [];
    level1Keys && level1Keys.forEach((date) => {
        const currLevel2KeyArray = Object.keys(graphData[date]);
        currLevel2KeyArray.length > 0 && currLevel2KeyArray.forEach((val, idx) => {
            if (level2Keys.indexOf(val) === -1) {
                level2Keys.push(val);
            }
        });
    });
    const colors = getRandomUniqueColor(level1Keys.length);
    const entityColors = getRandomUniqueColor(entities.length);
    // entities && entities.forEach((ent) => {
    //     colors[ent.entity_name] = ent.color_code;
    // });

    if (level === ENTITY) {
        entities && entities.forEach((ent, idx) => {
            const label = ent.entity_name;
            const backgroundColor = (useDynamicEntityColors) ? (ent.color_code !== "#000000") ? ent.color_code : entityColors[idx] : entityColors[idx];
            const borderColor = backgroundColor;
            const borderWidth = 1;
            const data = [];
            level1Keys && level1Keys.forEach((date, idx) => {
                let currVal = 0;
                if (graphData[date].hasOwnProperty(selectedTheme) && graphData[date][selectedTheme].hasOwnProperty(ent.entity_name)) {
                    currVal = parseData(graphData[date][selectedTheme][ent.entity_name][currentMeasure], true);
                }
                data.push(currVal);
            });
            datasets.push({ label, backgroundColor, borderColor, borderWidth, data, lineTension: 0, fill: "false", barThcikness: "flex" });
        });
        return { labels: level1Keys, datasets };
    }
    level2Keys && level2Keys.forEach((val, idx) => {
        const label = val;
        const backgroundColor = colors[idx];
        const borderColor = backgroundColor;
        const borderWidth = 1;
        const data = [];
        level1Keys && level1Keys.forEach((date, idx) => {
            let currVal = 0;
            if (graphData.hasOwnProperty(date) &&
                graphData[date].hasOwnProperty(val) &&
                graphData[date][val].hasOwnProperty(selectedTheme) &&
                graphData[date][val][selectedTheme].hasOwnProperty(entity)) {
                currVal = parseData(graphData[date][val][selectedTheme][entity][currentMeasure], true);
            }
            data.push(currVal);
        });
        datasets.push({ label, backgroundColor, borderColor, borderWidth, data, lineTension: 0, fill: "false", barThcikness: "flex" });
    });
    return { labels: level1Keys, datasets };
}

const parseData = (value, float = false) => {
    let return_value = (float) ? Math.round(parseFloat(value * 100, 10)) / 100 : parseInt(value, 10);
    if (Number.isNaN(return_value)) {
        let newevalue = value.replace(/,/g, '')
        newevalue = (float) ? Math.round(parseFloat(newevalue * 100, 10)) / 100 : parseInt(newevalue, 10)
        return newevalue;
    }
    return return_value;
}
